import { useQuery } from "@tanstack/react-query"
import { getProcessedFiles } from "services/apiUpload"


const useGetProcessedFile = ({orderId,filename}) => {
  const{isPending: isFetching,data:processedData,refetch:refetchProcessed} = useQuery({
    queryKey:["processedFiles",orderId,filename],
    queryFn:async()=> {
      // console.log("on useGetProcessedFile:",orderId,filename)
      return await getProcessedFiles({orderId,filename})
    },
    enabled:!!orderId && !!filename,
    retry:false
  })
  return{isFetching,processedData,refetchProcessed}
}

export default useGetProcessedFile